import {AbstractDTO, DateCustom} from "frontend-core";
import {SegmentCommission, ISegmentCommissionDto} from "@/modules/Segmentation/models/SegmentCommission";
import {ValidationRuleResult} from "frontend-core/dist/models/AbstractDTO";

export class SegmentCommissionDto extends AbstractDTO {
    constructor(
        protected readonly model: SegmentCommission
    ) {
        super(model);

        this.rules = {
            commission: () => this.validateCommission(this.model.commission)
                || ["Размер текущей комиссии должен быть от 0 до 99,99"],
            futureCommission: () => {
                let result: ValidationRuleResult = true;
                let message: string[] = [];

                this.model.futureCommission.some((item) => {
                    let res: boolean = true;

                    if (this.validateCommission(item.commission)) {
                        message.push("Проверьте значение комиссии (от 0 до 99,99)");
                        res = false;
                    }

                    return res;
                })

                this.model.futureCommission.some((item) => {
                    let res: boolean = true;

                    if (item.dateStart.date.isSameOrBefore(DateCustom.dateNow.date)) {
                        message.push(`Проверьте даты (запланировать можно с ${DateCustom.dateNow.getDateAfter(1, "days")})`);
                        res = false;
                    }

                    return res;
                })

                return result || message;
            }
        }
    }

    private validateCommission(commission: number): boolean {
        return commission  >= 0 && commission < 100
    }

    serialize(): ISegmentCommissionDto {
        return {
            commission: this.model.commission,
            futureCommission: this.model.futureCommission.map((item) => {
                return {
                    commission: item.commission,
                    dateStartCommission: item.dateStart.apiFormatted,
                }
            }),
        }
    }
}
